import React from 'react'
import Footer from '../components/footer/Footer'
import MegaHeader from '../components/MegaHeader/MegaHeader'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import MegaMenu from '../components/MegaMenu/MegaMenu'

const TermsAndConditions = () => {

    const { t } = useTranslation("termsAndConditionsPage")
    const title = t("title", { returnObjects: true })
    const subtitle = t("subtitle", { returnObjects: true })
    const intro = t("intro", { returnObjects: true })
    const sections = t("sections", { returnObjects: true })
    const metaTitle = t("metaTitle", { returnObjects: true })

    return (
        <>
            <Helmet>
                <title>{metaTitle}</title>
                <meta
                    name="description"
                    content="Our Terms & Conditions outline the rules, limitations, & user responsibilities when accessing our website & services."
                />
            </Helmet>
            <MegaMenu />

            <div className="container py-5">
                <h1 className="mb-3 h3 fw-bold">{title}</h1>
                <h2 className="mb-3 h5 fw-semibold">{subtitle}</h2>
                <p className="mb-4">{intro}</p>

                {sections.map((section, index) => (
                    <div key={index} className="mb-5">
                        <h5 className="fw-semibold mb-2">{section.heading}</h5>

                        {section.points ? (
                            <ul className="list-unstyled ps-3">
                                {section.points.map((point, idx) => (
                                    <li key={idx} className="mb-2">
                                        <strong>{point.label}:</strong> {point.description}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="mb-2">{section.content}</p>
                        )}

                        {section.contact && (
                            <ul className="mt-2 ps-3">
                                <li>
                                    <strong>{section.contact.emailHeading}:</strong>{" "}
                                    {section.contact.email}
                                </li>
                                <li>
                                    <strong>{section.contact.phoneHeading}:</strong>{" "}
                                    {section.contact.phone}
                                </li>
                                <li>
                                    <strong>{section.contact.addresHeading}:</strong>{" "}
                                    {section.contact.address}
                                </li>
                            </ul>
                        )}
                    </div>
                ))}
            </div>

            <Footer />
        </>
    )
}

export default TermsAndConditions